<rlst-modal [header]="'Send Postcards'" (closeModal)="close()">
    <div class="postcards-modal">
        <form [formGroup]="form" class="d-flex flex-column postcards-modal__form">
            <div class="postcards-modal__section">
                <p class="postcards-modal__title">
                    Choose the Letter Case
                </p>
                <div class="postcards-modal__values d-flex justify-content-between">
                    <label class="custom-control custom-radio">
                        <input formControlName="fontCase" [value]="FONT_CASE.MIXED_CASE" tabindex="0" type="radio"
                            class="custom-control-input radio-primary" aria-labelledby="mixed">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description" id="mixed">Use mixed case</span>
                    </label>
                    <label class="custom-control custom-radio">
                        <input formControlName="fontCase" [value]="FONT_CASE.CAPITAL_CASE" tabindex="0" type="radio"
                            class="custom-control-input radio-primary" aria-labelledby="all">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description" id="all">Use all capital letters</span>
                    </label>
                </div>
            </div>
            <div class="postcards-modal__section">
                <p class="postcards-modal__title">
                    Choose the Address Type
                </p>
                <div class="postcards-modal__values d-flex justify-content-between">
                    <label class="custom-control custom-radio">
                        <input formControlName="addressType" [value]="ADDRESS_TYPE.TAXBILLING" tabindex="0" type="radio"
                            class="custom-control-input radio-primary" aria-labelledby="mixed">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description" id="mixed">Use Tax Billing Address</span>
                    </label>
                    <label class="custom-control custom-radio">
                        <input formControlName="addressType" [value]="ADDRESS_TYPE.ADDRESS" tabindex="0" type="radio"
                            class="custom-control-input radio-primary" aria-labelledby="all">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description" id="all">Use Property Address</span>
                    </label>
                </div>
                <div class="postcards-modal__additonal-values">
                    <label class="custom-checkbox">
                        <input type="checkbox" formControlName="duplicateLabelsAllowed"
                            class="custom-control-input checkbox-default">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-description">Eliminate Duplicate Labels</span>
                    </label>
                </div>
            </div>
            <div class="postcards-modal__section d-none">
                <p class="postcards-modal__title">
                    Summary of Records to be Exported
                </p>
                <ag-grid-angular class="ag-theme-balham"
                    [rowData]="rowData"
                    [columnDefs]="columnDefs"
                    [gridOptions]="gridOptions"
                    (gridReady)="onGridReady($event)"
                >
                </ag-grid-angular>
                <div class="postcards-modal__pagination">
                    <rlst-pagination [currentPageNumber]="gridApi?.paginationGetCurrentPage() + 1"
                        [totalPages]="gridApi?.paginationGetTotalPages()"
                        (previousClicked)="gridApi?.paginationGoToPreviousPage()"
                        (nextClicked)="gridApi?.paginationGoToNextPage()"
                        (pageNumberChanged)="gridApi?.paginationGoToPage($event - 1)"></rlst-pagination>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <rlst-export-options [isNewTheme]="true" (range)="setRange($event)" (exportRangeValid)="setExportRangeValidity($event)"
                    [recordsNumber]="rowData?.length"></rlst-export-options>
                <rlst-export-limit-status [isNewTheme]="true" [exportInfo]="exportInfo$ | async"
                    [recordsNumber]="rowData?.length"></rlst-export-limit-status>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <div class="postcards-modal__error-note">
                    <p *ngIf="isLimitExceeded()" class="m-0">Limit has been exceeded. No records available for download.</p>
                </div>
                <div class="postcards-modal__buttons d-flex justify-content-end">
                    <button type="button" (click)="close()" class="postcards-modal__button cancel">Cancel</button>
                    <button type="button" [disabled]="!isExportRangeValid || isLimitExceeded()" (click)="create()"
                        class="postcards-modal__button create">Create</button>
                </div>
            </div>
        </form>
    </div>
</rlst-modal>
